import styles from './Terminals.module.scss';
import PropTypes from 'prop-types';
import { sanitizePhoneNumber } from '../../utils/phone';
import OpeningHours from './OpeningHours';
import { useTranslation } from 'react-i18next';

const AgencyInfo = ({ agencyInfo }) => {
    const { t } = useTranslation();
    if (!agencyInfo) {
        return null;
    }
    const { title, email, phone, openingHours, address, city, zip, openingHoursText, notes } =
        agencyInfo;

    return (
        <div className={styles.InfoSection}>
            <div className={styles.InfoSectionGroup}>
                {title && <p className={styles.InfoSectionName}>{title}</p>}
                {address && <p>{address}</p>}
                <p>{[zip, city].filter(Boolean).join(' ')}</p>
            </div>
            <OpeningHours hours={openingHours} openingHoursText={openingHoursText} />

            {phone || email ? (
                <div className={styles.InfoSectionGroup}>
                    <h3 className={styles.InfoSectionGroupHeader}>{t('terminals.contact')}</h3>
                    {phone && <a href={`tel:${sanitizePhoneNumber(phone)}`}>{phone}</a>}
                    {email && <a href={`mailto:${email}`}>{email}</a>}
                </div>
            ) : null}

            {notes && (
                <div className={styles.InfoSectionGroup}>
                    <h3 className={styles.InfoSectionGroupHeader}>
                        {t('terminals.furtherInformation')}
                    </h3>
                    <p>{notes}</p>
                </div>
            )}
        </div>
    );
};

AgencyInfo.propTypes = {
    agencyInfo: PropTypes.shape({
        title: PropTypes.string,
        city: PropTypes.string,
        phone: PropTypes.string,
        email: PropTypes.string,
        openingHours: PropTypes.arrayOf(
            PropTypes.shape({
                text: PropTypes.string,
                from: PropTypes.string,
                until: PropTypes.string,
            })
        ),
    }).isRequired,
};

AgencyInfo.displayName = 'AgencyInfo';

export default AgencyInfo;
